import { createDefaultTyrann } from '@apis/common';
import { fcProxyPost, fcProxy } from '@models/FCProxy';
import * as t from 'io-ts';

export const fcProxyApis = createDefaultTyrann({
  '/e2e/fc/': {
    post: {
      body: fcProxyPost,
      response: {
        200: fcProxyPost,
      },
    },
    get: {
      query: t.type({
        fc_api: t.string,
      }),
      response: {
        200: fcProxy,
      },
    },
  },
});
